import { httpsCallable } from 'firebase/functions';
import { functions } from '../../lib/firebase';

export async function trackerCoachRequest(action, data = {}) {
    return (await httpsCallable(functions, 'studyTrackerCoach', { timeout: 60000 })({ ...data, action })).data;
}
